
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getImageURL } from '@/utils/getters';

@Component
export default class KioskWelcomeModal extends Vue {
    @Prop({ required: true }) imageSrc!: string;
    @Prop({ required: true }) restaurantName!: string;

    private get imageURL(): string {
    	return getImageURL(this.imageSrc);
    }
}
